import { render } from "./PracticeProductsArchive.vue?vue&type=template&id=fb696426&scoped=true"
import script from "./PracticeProductsArchive.vue?vue&type=script&lang=js"
export * from "./PracticeProductsArchive.vue?vue&type=script&lang=js"

import "./PracticeProductsArchive.vue?vue&type=style&index=0&id=fb696426&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb696426"]])

export default __exports__